import { redirect } from 'react-router-dom';
import landingLoader from './landing';
import landingV2 from './landingV2';
import {
  selectLandingUseFakeData,
  selectLandingV2Flag
} from '../stores/launchDarkly';

// const fakeDataSlugEligible = [
//   'london',
//   'o2-arena',
//   'stansted-airport',
//   'brighton',
//   'manchester',
//   'manchester-airport',
//   'wembley-stadium',
//   'liverpool',
//   'luton-airport',
//   'york',
//   'stanmore',
//   'heathrow-airport',
//   'gatwick-airport',
//   'bristol',
//   'birmingham',
//   'glasgow',
//   'edinburgh',
//   'excel',
//   'birmingham-airport',
//   'twickenham',
//   'bath'
// ];

const fakeDataSlugEligible = [
  'london',
  'brighton',
  'manchester',
  'liverpool',
  'york',
  'bristol',
  'birmingham',
  'glasgow',
  'edinburgh'
];

export const isNewLandingEligible = (params) => {
  const { country, slug } = params;
  return (
    country === 'uk' &&
    fakeDataSlugEligible.includes(slug) &&
    params['*'] === ''
  );
};

const handleRedirects = (data) => {
  const newSlug = data?.newSlug || data?.data?.landing?.newSlug;
  const hasError = data?.hasError || data?.data?.landing?.hasError;

  if (newSlug) {
    return redirect(newSlug);
  }

  if (hasError) {
    return redirect('/');
  }

  return data;
};

const rootLandingLoader = async ({
  params,
  jpApiClient,
  apolloClient,
  storeState,
  request
}) => {
  const isEligible = isNewLandingEligible(params);
  const landingV2Flag = selectLandingV2Flag(storeState);
  const useFakeData = selectLandingUseFakeData(storeState);

  const { url } = request;
  const { pathname } = new URL(url);

  if (landingV2Flag && isEligible) {
    const data = await landingV2({
      apolloClient,
      useFakeData,
      pathname
    });

    return handleRedirects(data);
  }

  const data = await landingLoader({ params, jpApiClient, pathname });
  return handleRedirects(data);
};

export default rootLandingLoader;
